import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import { ICaseDecision } from "../model/CaseDecision";
import CaseDecisionMapper from "../service/CaseDecisionMapper";
import CaseDecisionParamMapper from "../service/CaseDecisionParamMapper";

export default class GetInvalidatedCaseDecisionsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseDecision>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseDecisionId: string) {
    return this.resource.execute(
      `${Constants.endpointBasePath}/${caseDecisionId}/invalidated`,
      CaseDecisionMapper,
      CaseDecisionParamMapper
    );
  }
}
